import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e222a300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-wrapper mt-4" }
const _hoisted_2 = { class: "row mt-6" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2" }, "Выбрать роль", -1))
const _hoisted_5 = { class: "checkbox-group mb-3" }

import { reactive, ref } from 'vue';
import { useTrackersStore } from '@/stores/trackers';
import { useDialogStore } from '@/stores/dialogs';
import VDialogHeader from './VDialogHeader.vue';
import { useErrors } from '@/utils/use-errors';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddUserDialog',
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as { user?: any }


const values = reactive<any>({})
const inputRef = ref<HTMLInputElement>()

if (props.user) {
  values.name = props.user.name
  values.email = props.user.email
  values.telegram = props.user.telegram
  values.bio = props.user.bio
  values.isSupervisor = props.user.isSupervisor
  if (props.user.avatar) {
    values.avatar = { src: props.user.avatar }
  }
}

const onFileChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files
  if (!files || !files[0]) return
  values.avatar = { src: URL.createObjectURL(files[0]), file: files[0] }
}

const trackersStore = useTrackersStore()
const dialogStore = useDialogStore()

const required = [ 'email', 'name' ]
if (!props.user) {
  required.push('password')
}

const errors = useErrors(values)

const pending = ref(false)
const submit = async () => {
  if (pending.value) return
  for (let key of required) {
    if (!values[key]) {
      errors[key] = "Поле должно быть заполнено"
    }
  }
  if (Object.keys(errors).length > 0) return

  pending.value = true
  try {
    if (props.user) {
      await trackersStore.editTracker(props.user.id, values)
    } else {
      await trackersStore.createTracker(values)
    }
    dialogStore.close()
  } catch(e: any) {
    if (e.error) {
      Object.assign(errors, e.error)
    }
    pending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.user)
      ? (_openBlock(), _createBlock(VDialogHeader, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("Редактировать данные сотрудника")
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(VDialogHeader, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("Добавить сотрудника")
          ]),
          _: 1
        })),
    _createVNode(_component_v_form, {
      class: "dialog-content pb-6",
      onSubmit: _withModifiers(submit, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_avatar, {
            color: "grey-lighten-1",
            size: "60",
            image: values['avatar']?.src
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: "white" }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-account")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["image"]),
          _createVNode(_component_v_btn, {
            icon: "",
            size: "small",
            color: "primary",
            width: "22",
            height: "22",
            class: "edit-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (inputRef.value?.click()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "x-small" }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-pencil")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_text_field, {
            modelValue: values.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values.email) = $event)),
            "error-messages": _unref(errors)['email'],
            variant: "outlined",
            label: "Почта"
          }, null, 8, ["modelValue", "error-messages"]),
          _createVNode(_component_v_text_field, {
            modelValue: values.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((values.password) = $event)),
            "error-messages": _unref(errors)['password'],
            variant: "outlined",
            "prepend-inner-icon": "mdi-key",
            label: props.user? 'Изменить пароль': 'Пароль'
          }, null, 8, ["modelValue", "error-messages", "label"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_text_field, {
            modelValue: values.name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((values.name) = $event)),
            "error-messages": _unref(errors)['name'],
            variant: "outlined",
            label: "Имя"
          }, null, 8, ["modelValue", "error-messages"]),
          _createVNode(_component_v_text_field, {
            modelValue: values.telegram,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((values.telegram) = $event)),
            "error-messages": _unref(errors)['telegram'],
            placeholder: "@nickname",
            variant: "outlined",
            "prepend-inner-icon": "mdi-send",
            label: "Телеграм"
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_checkbox, {
            label: "Трекер",
            "hide-details": "",
            color: "primary",
            "model-value": true
          }),
          _createVNode(_component_v_checkbox, {
            modelValue: values.isSupervisor,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((values.isSupervisor) = $event)),
            label: "Супервайзер",
            "hide-details": "",
            color: "primary"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_textarea, {
          modelValue: values.bio,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((values.bio) = $event)),
          label: "Био",
          variant: "outlined",
          color: "primary"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: submit,
          disabled: pending.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Сохранить")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          type: "file",
          accept: "image/*",
          class: "d-none",
          onChange: onFileChange
        }, null, 544)
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ], 64))
}
}

})